import {loadStripe} from '@stripe/stripe-js';

import {env} from '@shared/env_constants';

export const stripePromise = loadStripe(env.stripe.apiPublishableKey);
